































import { Component, Emit } from 'nuxt-property-decorator'
import { ComponentVue } from '@/base'
import ModalFooter from '@/components/molecules/ModalFooter/ModalFooter.vue'

@Component({
  components: {
    ModalFooter
  }
})
export default class ModalBibliographyRealPrintSelection extends ComponentVue {
  dialog = false

  open(): void {
    this.dialog = true
  }

  close(): void {
    this.dialog = false
  }

  @Emit('click:receipt-print')
  onClickReceiptPrint(): void {
    this.close()
  }

  @Emit('click:receipt-print-single')
  onClickReceiptPrintSingle(): void {
    this.close()
  }
}
